(function() {
  "use strict";

  angular.module("WorkstationProperties")

    .constant('WORKSTATION_PROPERTIES_TABS', [
      {
        icon: 'icon-gear',
        section: 'setup',
        caption: 'Setup',
        selected: false,
        show: true
      },
      {
        icon: 'icon-group',
        section: 'groups',
        caption: 'Groups',
        selected: false,
        show: true
      },
      {
        icon: 'icon-paper-tray-2',
        section: 'queues',
        caption: 'PrintQueues',
        selected: false,
        show: true
      },
      {
        icon: 'icon-pending-tasks',
        section: 'tasks',
        caption: 'Tasks',
        selected: false,
        show: true
      },
      {
        icon: 'icon-diagnostics',
        section: 'diagnostics',
        caption: 'Diagnostics',
        selected: false,
        show: true
      },
      {
        icon: 'icon-history',
        section: 'history',
        caption: 'History',
        selected: false,
        show: true
      }
    ])

    .controller("WorkstationPropertiesController", [
      "$scope", "$rootScope", "$location", "$filter", "URLS", "APIAdmin", "WorkstationListService",
      "Utils", "SUPPORTED_OS", "TenantListService", "$ngBootbox", "$routeParams", "URL_PARAMS", "toastr",
      "EventServiceEvents", "$http", "PrintQueueListPaging", "LOADER_CONSTANTS",
      "WORKSTATION_PROPERTIES_TABS", 'EventHandlerService', 'SnmpConfigurationService', "NetworkListPaging",
      '$timeout', 'NetworkListService', 'GroupListPaging', 'currentTenant',
      function(
        $scope, $rootScope, $location, $filter, URLS, APIAdmin, WorkstationListService,
        Utils, SUPPORTED_OS, TenantListService, $ngBootbox, $routeParams, URL_PARAMS, toastr,
        EventServiceEvents, $http, PrintQueueListPaging, LOADER_CONSTANTS,
        WORKSTATION_PROPERTIES_TABS, EventHandlerService, SnmpConfigurationService, NetworkListPaging,
        $timeout, NetworkListService, GroupListPaging, currentTenant) {

        $scope.tabs = WORKSTATION_PROPERTIES_TABS;
        $scope.tenantListService = TenantListService;

        $scope.printQueuesToBeChanged = [];

        $scope.me = null;
        $scope.isThisResourceMine = true;
        $scope.eventHandlerService = EventHandlerService;
        $scope.tenant = currentTenant;

        (function(){
          initEventHandler();
        })();

        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        };

        $scope.$watch(function() {
          return $rootScope.currentUser
        }, function() {
          if ($rootScope.currentUser) {
            $scope.me = $rootScope.currentUser;
            if ($routeParams[URL_PARAMS.WORKSTATION_ID.ROUTE]) {
              $scope.initWorkstation();
            } else {
              $location.path(URLS.WORKSTATION_LIST);
            }
          }
        })


        $scope.setSection = function(section) {
          $scope.showSection = section;

          var url = $location.path();
          $location.path(url, false).search({ workstationSection: section });
        }

        $scope.$watch(function()  {
          return $scope.showSection;
        }, function() {
          if ($scope.showSection) {
            switch ($scope.showSection) {
              case 'setup':
                $scope.helpCaption = "HelpComputersPropertiesSetup";
              break;
              case 'groups':
                $scope.helpCaption = "HelpComputersPropertiesGroups";
              break;
              case 'queues':
                $scope.helpCaption = "HelpComputersPropertiesPrintQueues";
              break;
              case 'tasks':
                $scope.helpCaption = "HelpComputersPropertiesTasks";
              break;
              case 'diagnostics':
                $scope.helpCaption = "HelpComputersPropertiesDiagnostics";
              break;
              case 'history':
                $scope.helpCaption = 'HelpComputersPropertiesHistory';
              break;
            }
          }
        }, true);

        (function() {
          if ($routeParams['workstationSection']) {
            $scope.showSection = $routeParams['workstationSection'];
          } else {
            $scope.showSection = 'setup';
          }
        })()

        $scope.storePrintQueuesToBeChanged = function (printQueuesToBeChanged) {
          $scope.printQueuesToBeChanged = printQueuesToBeChanged;

        }


        $scope.initWorkstation = function() {
          WorkstationListService.getWorkstationById($routeParams[URL_PARAMS.WORKSTATION_ID.ROUTE]).then(function(workstation) {
            if (workstation.info._embedded.queues) {
              workstation.info._embedded.queues = encodeQueueSelfLink(workstation.info._embedded.queues)
            }
            if (workstation.info._embedded.tasks) {
              workstation.info._embedded.tasks = encodeTaskQueueSelfLink(workstation.info._embedded.tasks)
            }
            isThisResourceMine(workstation);
            $scope.workstation = angular.copy(workstation);
            $scope.workstationOriginal = angular.copy(workstation);
            $rootScope.secondaryHeadline = $scope.workstation.info.name;
          }).catch(function(error){});
        };

        $scope.updateWorkstation = function (workstationInEvent) {
          WorkstationListService.getWorkstationById($routeParams[URL_PARAMS.WORKSTATION_ID.ROUTE]).then(function(workstation) {
            if (workstation.info._embedded.queues) {
              workstation.info._embedded.queues = encodeQueueSelfLink(workstation.info._embedded.queues)
            }
            if (workstation.info._embedded.tasks) {
              workstation.info._embedded.tasks = encodeTaskQueueSelfLink(workstation.info._embedded.tasks)
            }

            isThisResourceMine(workstation);
            $scope.workstation = angular.copy(workstation);
            $scope.workstationOriginal = angular.copy($scope.workstation);
            $rootScope.secondaryHeadline = $scope.workstation.info.name;
            $rootScope.$broadcast('RELAY_WS_UPDATE', {
              workstationInEvent: workstationInEvent,
              workstation: $scope.workstation,
              workstationOriginal: $scope.workstationOriginal,
              printQueuesToBeChanged: $scope.printQueuesToBeChanged
            })
          }).catch(function(error){});
        }

        function encodeQueueSelfLink (queues) {
          angular.forEach(queues, function(queue) {
            const printerId = queue._links['px:printer'].href.split('/').pop();
            queue.printerId = printerId;
            const queueId = queue._links['px:queue'].href.split('/').pop();
            queue.customProperties = {
              id: queueId,
            };
          })
          return queues
        }

        function encodeTaskQueueSelfLink (tasks) {
          angular.forEach(tasks, function(task) {
            if (task._links['px:queue']) {
              const printerId = task._links['px:printer'].href.split('/').pop();
              task.printerId = printerId;
              const queueId = task._links['px:queue'].href.split('/').pop();
              task.queueId = queueId;
            }
          })
          return tasks
        }

        function isThisResourceMine (workstation) {
          if (workstation.info._embedded.networks && workstation.info._embedded.networks.length > 0) {
            for (var i = 0; i < workstation.info._embedded.networks.length; i++) {
              var siteUrl = workstation.info._embedded.networks[i]._links['px:site'] ? workstation.info._embedded.networks[i]._links['px:site'].href : null;
              $scope.isThisResourceMine = $scope.me.isThisSiteMine(siteUrl);
              if ($scope.isThisResourceMine) {
                break;
              }
            }
          } else {
            if ($scope.me.permissions.TENANT_ADMIN) {
              $scope.isThisResourceMine = true;
            } else {
              $scope.isThisResourceMine = false;
            }
          }
        }


        // FIGURE OUT HOW TO UPDATE WORKSTATION WITHOUT SPAMMING THE SERVER WITH DOUBLE REQUEST
        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_UPDATED, function(name, data) {
          var workstationInEvent = Utils.removeDomainFromUrl(data.workstation);
          var workstationInScope = Utils.removeDomainFromUrl($scope.workstation.info._links.self.href);
          if (workstationInEvent === workstationInScope) {
            $scope.updateWorkstation(workstationInEvent);
          }
        });


        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_TASK_ADDED, function(name, data) {
          var workstationInEvent = Utils.removeDomainFromUrl(data.workstation);
          var workstationInScope = Utils.removeDomainFromUrl($scope.workstation.info._links.self.href);
          if (workstationInEvent === workstationInScope) {
            $scope.updateWorkstation(workstationInEvent);
          }
        });

        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_TASK_REMOVED, function(name, data) {
          var workstationInEvent = Utils.removeDomainFromUrl(data.workstation);
          var workstationInScope = Utils.removeDomainFromUrl($scope.workstation.info._links.self.href);
          if (workstationInEvent === workstationInScope) {
            $scope.updateWorkstation(workstationInEvent);

          }
        });

        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_TASK_STATUS_CHANGED, function(name, data) {
          var workstationInEvent = Utils.removeDomainFromUrl(data.workstation);
          var workstationInScope = Utils.removeDomainFromUrl($scope.workstation.info._links.self.href);
          if (workstationInEvent === workstationInScope) {
            $scope.updateWorkstation(workstationInEvent);
          }
        });

        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_QUEUE_ADDED, function(name, data){
          var workstationInEvent = Utils.removeDomainFromUrl(data.workstation);
          var workstationInScope = Utils.removeDomainFromUrl($scope.workstation.info._links.self.href);
          if (workstationInEvent === workstationInScope) {
            $scope.updateWorkstation(workstationInEvent);
          }
        });

        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_QUEUE_REMOVED, function(name, data){
          var workstationInEvent = Utils.removeDomainFromUrl(data.workstation);
          var workstationInScope = Utils.removeDomainFromUrl($scope.workstation.info._links.self.href);
          if (workstationInEvent === workstationInScope) {
            $scope.updateWorkstation(workstationInEvent);
          }
        });

        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.WORKSTATION_NETWORK_CHANGED, function(name, data){
          var workstationInEvent = Utils.removeDomainFromUrl(data.workstation);
          var workstationInScope = Utils.removeDomainFromUrl($scope.workstation.info._links.self.href);
          if (workstationInEvent === workstationInScope) {
            $scope.updateWorkstation(workstationInEvent);
          }
        });


        var REMEMBER_PRINTQUEUES_TASKS_IN_VIEW_SCOPE_listener = $rootScope.$on('REMEMBER_PRINTQUEUES_TASKS_IN_VIEW_SCOPE', function (name, data) {
          if (data.workstation.info._links.self.href === $scope.workstation.info._links.self.href) {
            $scope.printQueuesToBeChanged = data.printQueuesToBeChanged;
          }
          // {printQueuesToBeChanged: scope.printQueuesToBeChanged, workstation: scope.workstation}
        })

        $scope.$on('$destroy', function() {
          REMEMBER_PRINTQUEUES_TASKS_IN_VIEW_SCOPE_listener();
        });


      }
    ]);
})();